import {
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { changeFormulaType } from "../../actions/formulaAction";
import {
  formPostAction,
  getRememberSettings,
} from "../../actions/settingsActions";
import { getUserDetail } from "../../utils/helper";

const GranularToRawPopup = ({
  rememberSettings,
  closePopup,
  isRawType,
  setIsRaw,
  setPrepMethod,
  setRawGram,
  setTimePerDay,
  setDays,
  setScoops,
  preparationMethods,
}) => {
  const dispatch = useDispatch();
  const [scoop, setScoop] = useState(0);
  const [time, setTime] = useState(0);

  const updateField = (fields) => {
    const params = {
      token: getUserDetail()?.token,
      fields: fields,
      action: "updateRememberSettings",
    };

    dispatch(
      formPostAction(
        {
          params,
        },
        () => {
          dispatch(
            getRememberSettings(() => {
              closePopup();
            })
          );
        }
      )
    );
  };

  return (
    <Modal show={true} id="prescription-popup" size="lg">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">
                    We do not recommend starting in granular as different herbs
                    are produced at different concentrations, making it
                    complicated for you to calculate dosages. Write a raw
                    formula instead and we will accurately calculate the dosages
                    and conversions for you! Proceed with caution.{" "}
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 200, hide: 100 }}
                      overlay={
                        <Tooltip id="prescription-tooltip">
                          <p style={{ textAlign: "left" }}>
                            We have solved one of herbal medicine’s biggest
                            challenges: granular herb dosing.
                            <br /> <br /> ✅ Quality Herbs are no longer
                            granulated at a universal 5:1 ratio. Different
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;concentrations
                            are now used to optimize potency and quality. This
                            makes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;converting
                            herbs from raw to granular very difficult.
                            <br /> <br /> ✅ “3 scoops twice daily” serving
                            instructions is outdated and inaccurate. Each
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;formula has a
                            unique therapeutic dose (grams/day). Some formulas
                            maybe 2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;scoops
                            and another 10 scoops per day.
                            <br /> <br /> ✅ Dosage vs. Dosing: <br /> <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosage = amount
                            in grams per herb in a formula.
                            <br /> <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dosing
                            (therapeutic dose) = how much of the finished
                            formula to be taken per
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;day. In Raw the
                            standard daily dose of a formula is 1 Packet per day
                            whereas in
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;granular it is
                            the number of grams per day (needs to be
                            calculated).
                            <br /> <br />
                            ⭐Start by writing your formulas in RAW, and MHP
                            will auto-convert to granular AND
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;provide the
                            recommended daily therapeutic dose! This is a huge
                            leap for our
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;industry—and
                            we’re proud to lead the way. <br /> <br />
                          </p>
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        style={{ cursor: "pointer" }}
                      />
                    </OverlayTrigger>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <div className="custom-control custom-checkbox custom-popup">
              <input
                type="checkbox"
                className="custom-control-input hidden-checkbox"
                id="remember"
                style={{ color: "white", marginRight: "10px" }}
                checked={!rememberSettings?.showGranularConversionPopup}
                onChange={() => {
                  updateField({
                    ...rememberSettings,
                    showGranularConversionPopup: 0,
                  });
                }}
              />
              <label
                className="custom-control-label on-builder"
                style={{
                  color: "white",
                  marginLeft: "10px",
                  paddingTop: "4px",
                  paddingLeft: "5px",
                }}
                htmlFor="remember"
              >
                Do not show this message again
              </label>
            </div>
            <button
              className="btn-orange"
              onClick={() => {
                setRawGram();
                dispatch(changeFormulaType(!isRawType, 0));
                setPrepMethod &&
                  setPrepMethod(preparationMethods?.find((x) => x.id == 1));
                closePopup();
                setDays(1);
                setTimePerDay && setTimePerDay(1);
                setScoops && setScoops(1);
              }}
            >
              Proceed
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default GranularToRawPopup;
